import { SVGComponentPropsType } from 'assets/types';
import colors from 'styles/colors';

const defaultSize = 14;

const DraftStatusIcon = ({
  size = defaultSize,
  color = colors.agreementStatusDraft,
  ...props
}: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M7 1l5.985 5.964a.051.051 0 0 1 0 .072h0l-5.949 5.949a.051.051 0 0 1-.072 0h0L1.015 7.036a.051.051 0 0 1 0-.072h0l5.949-5.949A.051.051 0 0 1 7 1h0z"
      stroke={color}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default DraftStatusIcon;
